import { Console } from "console";
import ComingSoon from "pages/ComingSoon";
import { getPeriodDates, getPeriodMonths } from "utils/dateUtil";
import {
  getYMDFormatDTString,
  getYMDHMSFormatDTString,
  getYMFormatDTString,
} from "utils/dateUtil";
import axios from "./axios";
import { API_ERROR_CODE } from "./utils/dataCenter";

const prefix = "/v2/sales";

export function getHeadquarterSalesByDate(
  COMPANY_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_IDS: JSON.stringify(COMPANY_IDS),
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });

      const response = await axios.get(
        `${prefix}/getHeadquarterSalesByDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getHeadquarterSalesByDate error: `, e);
      reject(e);
    }
  });
}

export function getHeadquarterSalesMontly(
  COMPANY_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_IDS: JSON.stringify(COMPANY_IDS),
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });

      const response = await axios.get(
        `${prefix}/getHeadquarterSalesMontly?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getHeadquarterSalesMontly error: `, e);
      reject(e);
    }
  });
}

export function getHeadquarterSalesByOrderKinds(
  COMPANY_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_IDS: JSON.stringify(COMPANY_IDS),
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });

      const response = await axios.get(
        `${prefix}/getHeadquarterSalesByOrderKinds?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getHeadquarterSalesByOrderKinds error: `, e);
      reject(e);
    }
  });
}

export function getHeadquarterSalesByBrandDate(
  COMPANY_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_IDS: JSON.stringify(COMPANY_IDS),
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });

      const response = await axios.get(
        `${prefix}/getHeadquarterSalesByBrandDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getHeadquarterSalesByBrandDate error: `, e);
      reject(e);
    }
  });
}

export function getHeadquarterSalesByBrandMonth(
  COMPANY_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_IDS: JSON.stringify(COMPANY_IDS),
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });

      const response = await axios.get(
        `${prefix}/getHeadquarterSalesByBrandMonth?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getHeadquarterSalesByBrandMonth error: `, e);
      reject(e);
    }
  });
}

export function getCompanySalesLastDate(COMPANY_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID });
      const response = await axios.get(
        `${prefix}/getCompanySalesLastDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanySalesLastDate error: `, e);
      reject(e);
    }
  });
}

export function getCompanySalesLastDay(COMPANY_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID });
      const response = await axios.get(
        `${prefix}/getCompanySalesLastDay?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanySalesLastDay error: `, e);
      reject(e);
    }
  });
}

export function getCompanySalesWoW(COMPANY_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID });
      const response = await axios.get(
        `${prefix}/getCompanySalesWoW?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanySalesWoW error: `, e);
      reject(e);
    }
  });
}

export function getCompanySalesMoM(COMPANY_ID: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID });
      const response = await axios.get(
        `${prefix}/getCompanySalesMoM?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanySalesMoM error: `, e);
      reject(e);
    }
  });
}

export function getShopSalesByDate(
  SHOP_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        SHOP_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        // searchDates: JSON.stringify(getPeriodDates(getYMDFormatDTString(startDate), getYMDFormatDTString(endDate)))
      });

      const response = await axios.get(
        `${prefix}/getShopSalesByDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopSalesByDate error: `, e);
      reject(e);
    }
  });
}

export function getShopSalesMonthly(
  SHOP_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        SHOP_ID,
        startDate: getYMFormatDTString(startDate),
        endDate: getYMFormatDTString(endDate),
        // searchMonths: JSON.stringify(getPeriodMonths(getYMDFormatDTString(startDate), getYMDFormatDTString(endDate)))
      });
      const response = await axios.get(
        `${prefix}/getShopSalesMonthly?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopSalesMonthly error: `, e);
      reject(e);
    }
  });
}

export function getShopProductSalesByDateRange(
  COMPANY_ID: string,
  SHOP_ID: string,
  startDate: Date,
  endDate: Date,
  PRODUCT_PATH: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      const searchParams = new URLSearchParams({
        COMPANY_ID,
        SHOP_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        PRODUCT_PATH,
      });
      const response = await axios.get(
        `${prefix}/getShopProductSalesByDateRange?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopProductSalesByDateRange error: `, e);
      reject(e);
    }
  });
}

export function getCompanyProductSalesByDateRange(
  COMPANY_ID: string,
  startDate: Date,
  endDate: Date,
  PRODUCT_PATH: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      const searchParams = new URLSearchParams({
        COMPANY_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        PRODUCT_PATH,
      });
      const response = await axios.get(
        `${prefix}/getCompanyProductSalesByDateRange?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanyProductSalesByDateRange error: `, e);
      reject(e);
    }
  });
}

export function getCompanyAllProductSalesByDateRange(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const response = await axios.post(
        `${prefix}/getCompanyAllProductSalesByDateRange`,
        {
          COMPANY_ID,
          SHOP_IDS,
          startDate: getYMDFormatDTString(startDate),
          endDate: getYMDFormatDTString(endDate),
        }
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanyAllProductSalesByDateRange error: `, e);
      reject(e);
    }
  });
}

export function getCompanyShopProductSalesByDateRange(
  COMPANY_ID: string,
  startDate: Date,
  endDate: Date,
  PRODUCT_ID: string,
  ORDER_KINDS_LIST: any[]
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      const response = await axios.post(
        `${prefix}/getCompanyShopProductSalesByDateRange`,
        {
          COMPANY_ID,
          startDate: getYMDFormatDTString(startDate),
          endDate: getYMDFormatDTString(endDate),
          PRODUCT_ID,
          ORDER_KINDS_LIST,
        }
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanyShopProductSalesByDateRange error: `, e);
      reject(e);
    }
  });
}

export function getShopAllProductSalesByDateRange(
  COMPANY_ID: string,
  SHOP_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      const searchParams = new URLSearchParams({
        COMPANY_ID,
        SHOP_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });
      const response = await axios.get(
        `${prefix}/getShopAllProductSalesByDateRange?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopAllProductSalesByDateRange error: `, e);
      reject(e);
    }
  });
}

export function getShopSalesByOrderKinds(
  SHOP_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        SHOP_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        // searchDates: JSON.stringify(getPeriodDates(getYMDFormatDTString(startDate), getYMDFormatDTString(endDate))),
      });
      const response = await axios.get(
        `${prefix}/getShopSalesByOrderKinds?${searchParams.toString()}`
      );

      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopSalesByOrderKinds error: `, e);
      reject(e);
    }
  });
}

export function getShopSalesHouly(
  SHOP_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        SHOP_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        // searchDates: JSON.stringify(getPeriodDates(getYMDFormatDTString(startDate), getYMDFormatDTString(endDate))),
      });

      const response = await axios.get(
        `${prefix}/getShopSalesHouly?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopSalesHouly error: `, e);
      reject(e);
    }
  });
}

export function getCompanySalesByDate(
  COMPANY_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        // searchDates: JSON.stringify(getPeriodDates(getYMDFormatDTString(startDate), getYMDFormatDTString(endDate)))
      });

      const response = await axios.get(
        `${prefix}/getCompanySalesByDate?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanySalesByDate error: `, e);
      reject(e);
    }
  });
}

export function getCompanySalesMontly(
  COMPANY_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        startDate: getYMFormatDTString(startDate),
        endDate: getYMFormatDTString(endDate),
        // searchMonths: JSON.stringify(getPeriodMonths(getYMDFormatDTString(startDate), getYMDFormatDTString(endDate)))
      });
      const response = await axios.get(
        `${prefix}/getCompanySalesMontly?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanySalesMontly error: `, e);
      reject(e);
    }
  });
}

export function getCompanySalesByOrderKinds(
  COMPANY_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        // searchDates: JSON.stringify(getPeriodDates(getYMDFormatDTString(startDate), getYMDFormatDTString(endDate))),
      });

      const response = await axios.get(
        `${prefix}/getCompanySalesByOrderKinds?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanySalesByOrderKinds error: `, e);
      reject(e);
    }
  });
}

export function getCompanySalesHouly(
  COMPANY_ID: string,
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
        // searchDates: JSON.stringify(getPeriodDates(getYMDFormatDTString(startDate), getYMDFormatDTString(endDate))),
      });

      const response = await axios.get(
        `${prefix}/getCompanySalesHouly?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanySalesHouly error: `, e);
      reject(e);
    }
  });
}

export function getReportSalesByDate(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const response = await axios.post(`${prefix}/getReportSalesByDate?`, {
        COMPANY_ID,
        SHOP_IDS,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getReportSalesByDate error: `, e);
      reject(e);
    }
  });
}

export function getReportSalesByOrderKinds(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      const response = await axios.post(
        `${prefix}/getReportSalesByOrderKinds`,
        {
          COMPANY_ID,
          SHOP_IDS,
          startDate: getYMDFormatDTString(startDate),
          endDate: getYMDFormatDTString(endDate),
        }
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getReportSalesByOrderKinds error: `, e);
      reject(e);
    }
  });
}

export function getReportSalesByHour(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      const response = await axios.post(`${prefix}/getReportSalesByHour`, {
        COMPANY_ID,
        SHOP_IDS,
        startDate: getYMDFormatDTString(startDate),
        endDate: getYMDFormatDTString(endDate),
      });
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getReportSalesByHour error: `, e);
      reject(e);
    }
  });
}

export function getReportProductSalesByShop(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      const response = await axios.post(
        `${prefix}/getReportProductSalesByShop`,
        {
          COMPANY_ID,
          SHOP_IDS,
          startDate: getYMDFormatDTString(startDate),
          endDate: getYMDFormatDTString(endDate),
        }
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getReportProductSalesByShop error: `, e);
      reject(e);
    }
  });
}

export function getReportProductSalesByOrderKinds(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      const response = await axios.post(
        `${prefix}/getReportProductSalesByOrderKinds`,
        {
          COMPANY_ID,
          SHOP_IDS,
          startDate: getYMDFormatDTString(startDate),
          endDate: getYMDFormatDTString(endDate),
        }
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getReportProductSalesByOrderKinds error: `, e);
      reject(e);
    }
  });
}

export function getReportProductSalesByProductPath(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  startDate: Date,
  endDate: Date
) {
  return new Promise(async (resolve, reject) => {
    try {
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      const response = await axios.post(
        `${prefix}/getReportProductSalesByProductPath`,
        {
          COMPANY_ID,
          SHOP_IDS,
          startDate: getYMDFormatDTString(startDate),
          endDate: getYMDFormatDTString(endDate),
        }
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getReportProductSalesByProductPath error: `, e);
      reject(e);
    }
  });
}
